<!--
 * @Author: ckj kaijun.cui@biz-united.com.cn
 * @Date: 2025-11-28 10:35:27
 * @LastEditors: ckj kaijun.cui@biz-united.com.cn
 * @LastEditTime: 2025-12-31 16:08:25
 * @Description:
-->
<script>
import TablePage from '@/found/components/table_page';
import Form from './form';
import DifferentFormTable from './form/DifferentFormTable.vue';

export default {
  extends: TablePage,
  components: {
    Form,
    DifferentFormTable,
  },
  data() {
    return {
      requestType: 'POST',
    };
  },
  mounted() {
    this.getConfigList('main_list');
  },
  methods: {
    modalClick({ val, row }) {
      if (val.code === 'reconciliation') {
        this.formName = 'Form';
        this.formConfig = {
          ...this.formConfig,
          code: 'add',
          row,
        };
        this.modalConfig.title = '对账';
        this.openModal();
      }
      if (val.code === 'view_differences') {
        this.formName = 'DifferentFormTable';
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.modalConfig.title = '查看差异项';
        this.openFull();
      }
    },
  },
};
</script>
